import React from "react";
import Classes from "./styles/style.module.css";
import CustomSwitch from "../../components/CustomSwitch";
import SoundIcon from "../../images/icons/sound.svg";
import { useSelector, useDispatch } from "react-redux";
import { setSoundMuted } from "../../redux/actions/User";

const SoundHandler = () => {
  const dispatch = useDispatch();
  const { soundMuted } = useSelector(({ user }) => user);
  const handleChangeNotification = () => {
    dispatch(setSoundMuted(!soundMuted));
  };

  return (
    <div className={Classes.sideItem}>
      <div className="d-flex align-items-center">
        <img src={SoundIcon} alt="sound icon" />
        <p>صدا </p>
      </div>
      <CustomSwitch value={soundMuted} OnChange={handleChangeNotification} />
    </div>
  );
};

export default SoundHandler;
